import { atom, atomEffect, swr } from '@exodus/headless-ui';
import { fromAmountAtom, fromSpendableBalanceAtom, limitsAtom, prefillIdAtom, minQuoteAtom, prefillsAtom, } from '../index.js';
const lastAppliedPrefillAtom = atom(null);
const isBalanceAnchored = (id) => id === 'max' || id === 'half';
const prefillsEffect = atomEffect((get, set) => {
    void get(minQuoteAtom);
    const prefillId = get(prefillIdAtom);
    if (!prefillId) {
        if (get(lastAppliedPrefillAtom) !== null)
            set(lastAppliedPrefillAtom, null);
        return;
    }
    const prefills = get(swr(prefillsAtom));
    const limits = get(swr(limitsAtom));
    if (!prefills.data || !limits.data || !prefills.key)
        return;
    if (prefills.validating || limits.validating)
        return;
    const limitsKey = `${limits.data.ExactIn.min.toBaseString()}|${limits.data.ExactIn.max.toBaseString()}`;
    const scopeKey = prefills.key;
    const lastApplied = get(lastAppliedPrefillAtom);
    const nextValue = prefills.data[prefillId].value;
    const balance = get(fromSpendableBalanceAtom);
    const fromAmount = get(fromAmountAtom);
    if (lastApplied !== null && lastApplied.id === prefillId) {
        if (lastApplied.scopeKey === scopeKey &&
            lastApplied.limitsKey === limitsKey &&
            fromAmount.lte(balance)) {
            return;
        }
        if (isBalanceAnchored(prefillId) && nextValue.gt(balance))
            return;
    }
    set(fromAmountAtom, nextValue);
    set(lastAppliedPrefillAtom, { id: prefillId, limitsKey, scopeKey });
});
export default prefillsEffect;
